"use client";

import { openModal } from "action/modal/openModal";
import { MAKE_MODEL_YEAR, YEAR_MAKE_MODEL } from "component/vehicle-form/constants";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PAGE_TYPES, TIER_MAKE_MODEL_PAGES } from "util/product/product-constants";
import Button from "../../../component/design-system/buttons/Button";

interface IProps {
  onVehicleChange: () => void;
  inlineVehicleSelector?: boolean;
  className?: string;
}
function ChangeVehicleButton(props: IProps) {
  const {
    onVehicleChange, inlineVehicleSelector, className = "", defaultButtonType,
  } = props;

  const { selectedVehicle, defaultValues } = useSelector((store: RootState) => store.garage);
  const { currentPageType } = useSelector((store: RootState) => store.utils);
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const selectionOrder = [...TIER_MAKE_MODEL_PAGES, PAGE_TYPES.PRODUCT_MAKE_MODEL_PAGE].includes(currentPageType) ? MAKE_MODEL_YEAR : YEAR_MAKE_MODEL;
  const [showInlineSelector, setShowInlineSelector] = useState(true);

  function handleVehicleOnChange() {
    if (inlineVehicleSelector) {
      // If vehicle selector or add to cart modal is opened, don't open the vehicle selector modal. Just open the vehicle fitment selector
      setShowInlineSelector(false);
      onVehicleChange();
    } else {
      // use prefilled values only when vehicle is not selected
      dispatch(openModal("vehicleSelector", {
        ...(!selectedVehicle && selectionOrder),
        ...(!selectedVehicle && defaultValues),
        forceTrigger: true,
      }));
    }
  }

  if (!showInlineSelector) {
    return null;
  }

  return (
    <Button
      className={`m-t-10 ${className}`}
      variant="primary-outline"
      fullWidth
      onClick={handleVehicleOnChange}
    >
      { (selectedVehicle ? t("Change Vehicle") : t("Select Your Vehicle"))}
    </Button>
  );
}

export default ChangeVehicleButton;
